/* Take Sally: email-for-10%-off. The code is only shown after an email is entered,
   and it is added to the shopper's basket so it applies at checkout. */
(function () {
  var STORE = 'sally_offer_state';
  var CLAIMED = 'sally_newsletter_code_seen'; // same key the footer already used

  function getCode() {
    try { return window.SALLY_OFFER && window.SALLY_OFFER.c ? atob(window.SALLY_OFFER.c) : ''; } catch (e) { return ''; }
  }
  function store(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v); }

  var modal, lastFocus;

  function applyDiscount() {
    var code = getCode();
    if (!code) return Promise.resolve();
    return fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
  }

  // Public: save the email as a subscriber, apply the code, then show the code.
  window.SallyOffer = {
    claim: function (email) {
      var fd = new FormData();
      fd.append('form_type', 'customer');
      fd.append('utf8', '✓');
      fd.append('contact[email]', email);
      fd.append('contact[tags]', 'newsletter');
      return fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
        .catch(function () {})
        .then(applyDiscount)
        .then(function () {
          store(CLAIMED, '1');
          store(STORE, 'claimed');
          document.querySelectorAll('[data-offer-code], #ContactFooter-code-value').forEach(function (el) { el.textContent = getCode(); });
        });
    },
    open: function () { openModal(); },
    code: getCode
  };

  function showStep(name) {
    modal.querySelectorAll('[data-offer-step]').forEach(function (s) { s.hidden = s.getAttribute('data-offer-step') !== name; });
  }

  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    showStep(read(CLAIMED) === '1' ? 'done' : 'ask');
    if (read(CLAIMED) === '1') {
      modal.querySelectorAll('[data-offer-code]').forEach(function (el) { el.textContent = getCode(); });
    }
    modal.hidden = false;
    document.body.classList.add('welcome-offer-open');
    var input = modal.querySelector('input[type="email"]');
    if (input && read(CLAIMED) !== '1') setTimeout(function () { input.focus(); }, 50);
  }

  function closeModal() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.body.classList.remove('welcome-offer-open');
    if (read(CLAIMED) !== '1') store(STORE, 'dismissed:' + Date.now());
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function init() {
    modal = document.getElementById('welcome-offer');
    if (!modal) return;

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('a[href="#welcome-offer"], [data-open-offer]');
      if (opener) { e.preventDefault(); openModal(); return; }
      if (e.target.closest('[data-offer-close]')) { closeModal(); return; }
      var copy = e.target.closest('[data-offer-copy]');
      if (copy && navigator.clipboard) {
        navigator.clipboard.writeText(getCode()).then(function () {
          copy.textContent = 'Copied!';
          setTimeout(function () { copy.textContent = 'Copy'; }, 2000);
        });
      }
    });
    if (read(CLAIMED) === '1') {
      var fc = document.getElementById('ContactFooter-code-value');
      if (fc) fc.textContent = getCode();
    }
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeModal(); });

    var form = modal.querySelector('[data-offer-form]');
    var err = modal.querySelector('[data-offer-error]');
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = form.querySelector('input[type="email"]').value.trim();
      if (!validEmail(email)) { err.hidden = false; return; }
      err.hidden = true;
      var btn = form.querySelector('button');
      btn.disabled = true; btn.textContent = 'Unlocking…';
      window.SallyOffer.claim(email).then(function () {
        btn.disabled = false; btn.textContent = 'Unlock my 10%';
        showStep('done');
      });
    });

    // Friendly pop-up once, a little while after arriving (never on the cart page, never again once claimed or recently closed).
    var path = location.pathname;
    var skip = /^\/(cart|checkouts|account)/.test(path);
    var state = read(STORE) || '';
    var recentlyClosed = state.indexOf('dismissed:') === 0 && (Date.now() - parseInt(state.split(':')[1], 10)) < 7 * 24 * 3600 * 1000;
    if (!skip && read(CLAIMED) !== '1' && !recentlyClosed && !/theme_preview|preview_theme_id/.test(location.search)) {
      setTimeout(function () {
        if (!document.body.classList.contains('welcome-offer-open') && modal.hidden) openModal();
      }, 20000);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
